import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { Column } from '@miq/catalog';
import { UntilDestroy } from '@ngneat/until-destroy';

export const recordDetailsLabelTooltip: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  position: 'above',
  touchendHideDelay: 0,
  disableTooltipInteractivity: true,
};

@UntilDestroy()
@Component({
  selector: 'miq-record-detail-label, miq-column-label, [miqColumnLabel]',
  template: `
    <div class="recorddetailpage-container">
      <div class="detailpage-pinscontainer">
        <div class="detailpage-pinscontainer__label" [matTooltip]="column | columnTooltip">
          <span [ngClass]="{ clickable: clickable }" (click)="clicked.emit($event)">
            {{ finalConfig.labelText }}
          </span>
          <span *ngIf="required || (column && column.required)">
            <span class="required-icon"> &#x2a; </span>
          </span>
        </div>
        <ng-content select=".extra-icons"></ng-content>
        <ng-content select=".extra-text"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./record-detail-label.component.scss'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: recordDetailsLabelTooltip }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RecordDetailLabelComponent implements OnInit, OnChanges {
  @Input() column: Column;
  @Input() disablePinEvent = false;
  @Input() clickable = false;

  @Input() required: boolean;
  @Input() labelText: string;

  @Output() clicked = new EventEmitter();

  public finalConfig = {
    labelText: '',
  };

  ngOnInit() {
    this.initConfigs();
  }

  ngOnChanges({ column }: SimpleChanges) {
    if (column && column.currentValue != null) {
      this.initConfigs();
    }
  }

  private initConfigs() {
    if (this.column != null) {
      this.finalConfig.labelText = this.column.header;
    }
    this.finalConfig.labelText = this.labelText != null ? this.labelText : this.finalConfig.labelText;
  }
}
